var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.83,
    height: 54.817,
    viewBox: "0 0 54.83 54.817",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.502;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 -0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.225,28.383a17.349,17.349,0,0,0-10.191-7.6V17.418a2.741,2.741,0,1,0,0-5.483H39.293V9.194h4.569a.914.914,0,0,0,.914-.914V3.711A3.655,3.655,0,0,0,41.12.056H7.31A3.655,3.655,0,0,0,3.655,3.711V40.263H.914A.914.914,0,0,0,0,41.176V43a3.655,3.655,0,0,0,3.655,3.655H22.73A17.349,17.349,0,0,0,52.225,28.383ZM39.293,3.711a1.828,1.828,0,1,1,3.655,0V7.366H39.293Zm2.741,10.052a.914.914,0,1,1,0,1.828H32.9a.914.914,0,0,1,0-1.828h9.138ZM5.483,3.711A1.828,1.828,0,0,1,7.31,1.884H37.973a3.618,3.618,0,0,0-.508,1.828v8.224H32.9a2.741,2.741,0,1,0,0,5.483v3.363A17.2,17.2,0,0,0,20.342,40.263H5.483ZM3.655,44.832A1.828,1.828,0,0,1,1.828,43V42.09H20.734a17.206,17.206,0,0,0,1.005,2.741Zm33.81,8.224a15.528,15.528,0,0,1-3.452-30.669.914.914,0,0,0,.711-.892V17.418h5.483v4.076a.914.914,0,0,0,.711.892,15.528,15.528,0,0,1-3.452,30.669Z",
    transform: "translate(0 -0.056)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.656 26.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M230.52,228.681a12.84,12.84,0,0,0-5.9,6.422l1.687.7a11.009,11.009,0,0,1,5.061-5.507Z",
    transform: "translate(-224.616 -228.681)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.676 34.657)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M241.572,304.909a.914.914,0,0,0-1.558-.581l-.7.7a3.209,3.209,0,0,1-4.534,0l-.569-.569a5.04,5.04,0,0,0-7.12,0l-.569.569a3.209,3.209,0,0,1-4.534,0,5.051,5.051,0,0,0-5.3-1.152.914.914,0,0,0-.593.773c-.037.395-.06.793-.06,1.2a12.793,12.793,0,0,0,25.586,0C241.618,305.559,241.6,305.278,241.572,304.909Zm-12.751,11.9a10.977,10.977,0,0,1-10.965-10.966c0-.136,0-.274.009-.406a3.207,3.207,0,0,1,2.827.88,5.041,5.041,0,0,0,7.12,0l.569-.569a3.208,3.208,0,0,1,4.534,0l.569.569a5.045,5.045,0,0,0,6.238.7A10.981,10.981,0,0,1,228.821,316.813Z",
    transform: "translate(-216.032 -302.983)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.53 24.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.512,217.377a12.814,12.814,0,0,0-1.968.466l.561,1.736a10.916,10.916,0,0,1,1.687-.4Z",
    transform: "translate(-293.544 -217.377)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.054 38.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 0.551,
    height: 2.204,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.135 41.984)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.653,
    height: 2.755
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.4 44.739)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.653,
    height: 1.102,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.31 4.625)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.578,43.712l-2.957-1.479V40.057H76.793v2.177L74.052,43.6,71.31,42.234V40.057H69.483v2.177l-3.15,1.574a.914.914,0,0,0-.505.818v3.655H64v1.828h2.526l2.957,1.479v2.177H71.31V51.587l2.741-1.371,2.741,1.371v2.177h1.828V51.587l3.15-1.57a.914.914,0,0,0,.505-.822V45.54H84.1V43.712Zm-8.44,4.918L70.4,50,67.655,48.63v-3.44L70.4,43.82l2.741,1.371Zm7.31,0L77.707,50,74.965,48.63v-3.44l2.741-1.371,2.741,1.371Z",
    transform: "translate(-64 -40.057)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.44 23.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 15.429,
    height: 2.755
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.44 27.657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12.674,
    height: 2.755
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.44 31.514)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 9.919,
    height: 2.204
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.053 21.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 8.817,
    height: 1.653
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.033 5.615)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.102,
    height: 2.755,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.196 21.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1.653,
    height: 1.653
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.788 5.615)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.755,
    height: 2.755,
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.a102c591811de80e53597629bf719535.svg";
export { ForwardRef as ReactComponent };